import {
  IProxyError,
  IService,
  ITemplate,
  IUserProfile,
  ISender,
  IPriority,
  ICheckTemplateProxyResponse,
  IMNO,
  ITemplates,
  ICheckMNOMaskResponse,
  IMNOMask,
  IMNOSender,
  ITag,
} from '@/interfaces';
import { AdminState } from './state';
import { IServiceBanPolicy } from '@/interfaces/service_ban_policy';

export const mutations = {
  setUsers(state: AdminState, payload: IUserProfile[]) {
    state.users = payload;
  },
  setUser(state: AdminState, payload: IUserProfile) {
    const users = state.users.filter((user: IUserProfile) => user.id !== payload.id);
    users.push(payload);
    state.users = users;
  },
  setServices(state: AdminState, payload: IService[]) {
    state.services = payload;
  },
  setService(state: AdminState, payload: IService) {
    const services = state.services.filter((service: IService) => service.id !== payload.id);
    services.push(payload);
    state.services = services;
  },
  setServiceBanPolicies(state: AdminState, payload: IServiceBanPolicy[]) {
    state.serviceBanPolicies = payload;
  },
  setServiceBanPolicy(state: AdminState, payload: IServiceBanPolicy) {
    const serviceBanPolicies = state.serviceBanPolicies.filter(
      (serviceBanPolicy: IServiceBanPolicy) => serviceBanPolicy.id !== payload.id,
    );
    serviceBanPolicies.push(payload);
    state.serviceBanPolicies = serviceBanPolicies;
  },
  setTemplates(state: AdminState, payload: ITemplates) {
    state.templates = payload;
  },
  setTemplate(state: AdminState, payload: ITemplate) {
    const templateIndex = state.templates.items.findIndex((template: ITemplate) => template.id === payload.id);
    if (templateIndex !== -1) {
      state.templates[templateIndex] = payload;
    } else {
      state.templates.items.push(payload);
    }
  },
  setSenders(state: AdminState, payload: ISender[]) {
    state.senders = payload;
  },
  setSender(state: AdminState, payload: ISender) {
    const senders = state.senders.filter((sender: ISender) => sender.id !== payload.id);
    senders.push(payload);
    state.senders = senders;
  },
  setProxyErrors(state: AdminState, payload: IProxyError[]) {
    state.proxyErrors = payload;
  },
  setProxyError(state: AdminState, payload: IProxyError) {
    const proxyErrors = state.proxyErrors.filter((proxyError: IProxyError) => proxyError.id !== payload.id);
    proxyErrors.push(payload);
    state.proxyErrors = proxyErrors;
  },
  setPriorities(state: AdminState, payload: IPriority[]) {
    state.priorities = payload;
  },
  setPriority(state: AdminState, payload: IPriority) {
    const priorities = state.priorities.filter((priority: IPriority) => priority.id !== payload.id);
    priorities.push(payload);
    state.priorities = priorities;
  },
  setMNOs(state: AdminState, payload: IMNO[]) {
    state.mnos = payload;
  },
  setMNO(state: AdminState, payload: IMNO) {
    const mnos = state.mnos.filter((mno: IMNO) => mno.id !== payload.id);
    mnos.push(payload);
    state.mnos = mnos;
  },
  setMNOMasks(state: AdminState, payload: IMNOMask[]) {
    state.mnoMasks = payload;
  },
  setMNOSenders(state: AdminState, payload: IMNOSender[]) {
    state.mnoSenders = payload;
  },
  setTemplateProxyResponse(state: AdminState, payload: ICheckTemplateProxyResponse) {
    if (state.templateProxyResponse) {
      state.templateProxyResponse.response = payload.response;
      state.templateProxyResponse.status_code = payload.status_code;
    } else {
      state.templateProxyResponse = payload;
    }
  },
  setCheckMNOMaskResponse(state: AdminState, payload: ICheckMNOMaskResponse) {
    state.checkMNOMaskResponse = payload;
  },
  setTags(state: AdminState, payload: ITag[]) {
    state.tags = payload;
  },
};
